<template>
    <b-card>
        <div slot="header">
            <span class="font-weight-bold">
                Diseño de matriz de compatibilidad - {{ accion }} comparación de productos
            </span>
            <b-button @click="returnAndUpdate" size="sm" variant="secondary" class="float-right">
                <i class="fa fa-reply fa-lg" />
                Volver
            </b-button>
        </div>

        <form data-vv-scope="formulario" @submit.prevent="validarFormulario">
            <b-row>
                <div class="form-group col-md-6 col-wide-3">
                    <label for="fecha" class="w-100">
                        Fecha :
                    </label>
                    <el-date-picker v-model="comparacion.fecha" name="fecha" id="fecha" type="date" size="small"
                        class="w-100" value-format="yyyy-MM-dd" data-vv-as=" " v-validate="'required'" />
                    <span class="text-danger span-error small" v-text="errors.first('formulario.fecha')" />
                </div>

                <div class="form-group col-md-6 col-wide-3" v-if="this.validarPermisoComponente('matriz-compatibilidad-almacenamiento')">
                    <label for="id_empresa">
                        Empresa
                    </label>
                    <el-select v-model="comparacion.id_empresa" :disabled="accion !== 'Crear'" id="id_empresa"
                        name="id_empresa" filterable remote size="small" @change="onCompanyChange"
                        placeholder="Selecciona una empresa" no-data-text="No hay datos que coincidan"
                        no-match-text="No hay datos que coincidan" :remote-method="obtenerEmpresas" data-vv-as=" "
                        v-validate="'required'">
                        <el-option v-for="empresa in empresas" :key="empresa.id" :label="empresa.nombre"
                            :value="empresa.id" />
                    </el-select>
                    <span class="text-danger span-error small" v-text="errors.first('formulario.id_empresa')" />
                </div>

                <div class="form-group col-md-6 col-wide-3">
                    <label for="id_ubicacion">
                        Ubicación
                    </label>
                    <tree-select :value="comparacion.id_ubicacion" class="text-uppercase" size="sm" id="id_ubicacion"
                        name="id_ubicacion" :multiple="false" :defaultExpandLevel="Infinity" :options="ubicaciones"
                        :disabled="accion !== 'Crear'" @input="establecerIdUbicacion" />
                </div>

                <div class="form-group col-md-6 col-wide-3">
                    <label for="description">
                        Descripción
                    </label>
                    <el-input v-model="comparacion.descripcion" type="text" placeholder="Ingresa una descripción"
                        name="descripcion" id="descripcion" maxlength="256"
                        v-validate="'max:255'" data-vv-as="Descripción" />
                    <span class="text-danger span-error small" v-text="errors.first('formulario.descripcion')" />
                </div>
                
                
                <div class="form-group col-md-6 col-wide-3" v-if="accion === 'Editar' && customFields && customFields.length > 0">
                    <label>Campos Personalizados</label>
                    <el-select v-model="selectedCustomField"
                        name="id_custom_field" filterable size="small" clearable
                        placeholder="Selecciona un campo personalizado" no-data-text="No hay datos que coincidan"
                        no-match-text="No hay datos que coincidan" data-vv-as=" "
                        @change="onCustomFieldChange"
                    >
                        <el-option v-for="customField in customFields" :key="customField.id" :label="customField.nombre"
                            :value="customField.id" />
                    </el-select>
                </div>
            </b-row>

        </form>

        <b-row v-if="accion !== 'Crear'">
            <b-col cols="12" class="font-weight-bold">
                <hr />
                <h5 class="bg-light m-0 mb-3 p-2 rounded">
                    <i class="fa fa-search" />
                    Buscar productos
                </h5>
            </b-col>
            <b-col sm="4">
                <b-form-group>
                    <div class="d-flex align-items-center justify-content-between">
                        <label>Nombre</label>
                        <span class="d-inline-flex align-items-center">
                            <small class="mr-1 text-muted">¿Coincidencia exacta?</small>
                            <b-form-checkbox v-model="filtros_productos.exact_match" size="sm"/>
                        </span>
                    </div>
                    <b-form-input
                        v-model="filtros_productos.nombre"
                        id="producto1_nombre"
                        name="producto1_nombre"
                        type="text"
                        @keyup.enter="onBuscarProductos"
                    >
                    </b-form-input>
                </b-form-group>
            </b-col>

            <b-col sm="4">
                <b-form-group>
                    <label for="id_fabricante">Fabricante</label>
                    <el-select id="id_fabricante" name="id_fabricante" v-model="filtros_productos.id_fabricante"
                        filterable multiple remote size="small" clearable no-data-text="No hay datos que coincidan"
                        no-match-text="No hay datos que coincidan" :remote-method="obtenerFabricantes">
                        <el-option v-for="fabricante in fabricantes" :key="fabricante.id" :label="fabricante.nombre"
                            :value="fabricante.id" />
                    </el-select>
                </b-form-group>
            </b-col>

            <b-col cols="12" class="mb-2">
                <b-button @click.prevent="onLimpiarProductos" class="mx-1 float-right">
                    <i class="fa fa-eraser fa-lg"></i>
                    <span class="d-none d-md-inline-block">Limpiar</span>
                </b-button>
                <b-button variant="primary" @click.prevent="onBuscarProductos" class="mx-1 float-right">
                    <i class="fa fa-search fa-lg" />
                    <span class="d-none d-md-inline-block">Buscar</span>
                </b-button>
            </b-col>

            <!-- Mensaje de búsqueda inicial -->
            <b-col cols="12" v-if="esBusquedaInicial && productos.total > filtros_productos.perPage">
                <div class="alert alert-info text-center mb-2">
                    Se muestran los primeros 5 productos disponibles.
                </div>
            </b-col>

            <b-col cols="12">
                <b-table responsive hover small striped thead-class="table-active" show-empty
                    empty-text="No hay productos para mostrar" :items="productos.data" :fields="columnas">
                    <template v-slot:head(seleccion)="data1">
                        <b-form-checkbox v-b-tooltip.hover title="Seleccionar todos" @change="seleccionarTodos"
                            v-model="seleccionar_todos.valor" />
                    </template>
                    <template v-slot:cell(seleccion)="data">
                        <b-form-checkbox v-model="data.item.seleccionado"
                            @change="establecerProductosSeleccionados(data.item)" />
                    </template>
                </b-table>
                <el-pagination class="float-right" v-if="!filtros_productos.mostrar_todos"
                    v-model="filtros_productos.page" @size-change="onPaginate" @current-change="onPaginate"
                    :current-page.sync="filtros_productos.page" :page-sizes="[5, 30, 50, 100]"
                    :page-size.sync="filtros_productos.perPage" layout="total,sizes, prev, pager, next"
                    :total="productos.total" this.esBusquedaInicial = false />
            </b-col>

            <b-col cols="12" class="font-weight-bold text-center text-danger mt-2 mb-4"
                v-if="accion === 'Editar' && productos_seleccionados.length < 2">
                Debe seleccionar mínimo 2 productos para hacer el análisis
            </b-col>
            <b-col cols="12" class="font-weight-bold text-center text-primary mt-2 mb-4"
                v-else-if="accion === 'Editar'">
                {{ productos_seleccionados.length }} producto(s) seleccionado(s)
            </b-col>
        </b-row>

        <b-row>
            <b-col class="text-center">
                <hr />
                <b-button @click.prevent="validarFormulario" size="sm" variant="primary"
                    :disabled="accion === 'Editar' && productos_seleccionados.length < 2">
                    <i class="fa fa-floppy-o fa-lg" />
                    {{ titleBtn }}
                </b-button>

                <!-- Comparación con IA - btn. El tope se comprueba aquí y no al seleccionar
                     productos porque hasta que la comparación manual no calcula los
                     resultados no se sabe cuántos pares necesitan IA de verdad. -->
                <b-button @click.prevent="onHandleComparisonIA" size="sm" variant="info" class="ml-1" v-if="puedeCompararConIA">
                    <i class="fa fa-magic fa-lg" />  
                    Comparación con IA                  
                </b-button>

                <div class="text-warning mt-2" v-if="excedeLimiteIA">
                    <i class="fa fa-exclamation-triangle" />
                    Hay {{ conteoPendientes }} comparaciones por evaluar y
                    el máximo por proceso son {{ limitePares }}. Reduce productos o aprueba
                    primero las comparaciones pendientes.
                </div>

                <!-- Comparación con IA - Modal comparación -->
                <MatrixCompatibilityModalComparison ref="modalComparisonRef" />

            </b-col>
        </b-row>

        <compatibility ref="compatibilityRef" v-if="productos_seleccionados.length >= 2 && (Array.isArray(comparacion.matriz_compatibilidad_productos) && comparacion.matriz_compatibilidad_productos.length >= 2)"
            :comparacion="comparacion" :pending-count="pending_verifications_count" :custom-field-values="customFieldValues" :selected-custom-field="selectedCustomField"
            @handleGetComparacion="inicializarComponente(true)" @handleUpdateComparacion="inicializarComponente" />

        <b-row v-if="productos_seleccionados.length >= 2 && (Array.isArray(comparacion.matriz_compatibilidad_productos) && comparacion.matriz_compatibilidad_productos.length >= 2)">
            <b-col class="text-center">
                <hr />
                <b-button size="sm" variant="primary" @click="actionDescargarExcel(comparacion)">
                    <i class="fa fa-file-excel-o" />
                    Descargar matriz
                </b-button>
            </b-col>
        </b-row>

        <b-row>
            <b-col class="text-center">
                <b-button to="/matriz-compatibilidad/almacenamiento" size="sm" variant="secondary" class="float-left">
                    <i class="fa fa-reply fa-lg" />
                    Volver
                </b-button>
            </b-col>
        </b-row>

        <LoadingCompatibility :loading="initloading" :title="title" :message="message" />
    </b-card>
</template>

<script>

import { mapActions, mapMutations, mapState } from 'vuex'
import TreeSelect from '@riophae/vue-treeselect'
import Swal from 'sweetalert2'
import compatibility from './Compatibility.vue';
import LoadingCompatibility from './LoadingCompatibility.vue';
import { validarPermisoComponente } from "@/plugins/acl";

// Componentes
import MatrixCompatibilityModalComparison from '@/views/matrizCompatibilidad/almacenamiento/ia/ModalComparison.vue'

// Mixins 
import matrixCompatibilityIndex from '@/servicios/matrizCompatibilidad/compatibility/index.js'
import { LIMITE_PARES } from '@/servicios/matrizCompatibilidad/almacenamiento/state'
import customFields from '../../../servicios/administracion/customFields';

export default {
    name: 'formulario',
    components: {
        TreeSelect,
        compatibility,
        LoadingCompatibility,
        MatrixCompatibilityModalComparison
    },

    mixins: [matrixCompatibilityIndex],

    data() {
        return {
            columnas: [
                {
                    key: 'seleccion',
                    label: '',
                    sortable: false,
                },
                {
                    key: 'nombre',
                    label: 'NOMBRE',
                    sortable: false,
                },
                {
                    key: 'lista_estado.lista',
                    label: 'ESTADO',
                    sortable: false,
                },
                {
                    key: 'fabricante.nombre',
                    label: 'FABRICANTE',
                    sortable: false,
                },
            ],            
            validarPermisoComponente: validarPermisoComponente,
            company_id: null,
            esBusquedaInicial: true,
            selectedCustomField: null                              
        }
    },
    computed: {
        ...mapState('matrizCompatibilidadAlmacenamiento', [
            'empresas',
            'filtros_productos',
            'productos_seleccionados',
            'ubicaciones',
            'comparacion',
            'accion',
            'productos',
            'fabricantes',
            'seleccionar_todos',
            'resultado',
            'pending_verifications_count',
            'customFields',
            'customFieldValues'
        ]),
        ...mapState('autenticacion', ['usuarioAdmin']),
        titleBtn() {
            if (this.accion === 'Crear') {
                return 'Guardar'
            } else {
                return 'Comparación manual'
            }
        },

        limitePares() {
            return LIMITE_PARES
        },

        conteoPendientes() {
            if (this.pending_verifications_count !== null && this.pending_verifications_count !== undefined) {
                return Number(this.pending_verifications_count)
            }

            return Number(this.comparacion.pending_verifications_count || 0)
        },

        tienePermisoIA() {
            return this.accion === 'Editar'
                && this.conteoPendientes > 0
                && this.validarPermisoComponente('matriz-compatibilidad-proceso-ia')
        },

        excedeLimiteIA() {
            return this.tienePermisoIA && this.conteoPendientes > LIMITE_PARES
        },

        puedeCompararConIA() {
            return this.tienePermisoIA && !this.excedeLimiteIA
        },
    },
    async created() {
        if (!this.validarPermisoComponente('matriz-compatibilidad-almacenamiento')) {
            const id_empresa = await this.obtenerIdEmpresaUsuario();
            this.company_id = id_empresa;
            this.obtenerUbicaciones(id_empresa);
        }

        this.agregarProducto = false
        this.establecerAccion('Crear')
        this.restablecerComparacion()
        await this.inicializarComponente()
        this.load(false)
    },
    methods: {
        onPaginate() {
            this.esBusquedaInicial = false;
            this.cargarProductos();
        },
        ...mapActions('dashboard', ['validarPermiso', 'obtenerIdEmpresaUsuario']),
        ...mapMutations('dashboard', ['load']),
        ...mapMutations('matrizCompatibilidadAlmacenamiento', [
            'establecerIdEmpresaFiltro',
            'establecerIdUbicacion',
            'restablecerComparacion',
            'establecerIdUbicacionFiltrosProductos',
            'establecerAccion',
            'establecerProductosSeleccionados',
            'establecerUbicacion',
            'restablecerFiltrosProductos',
            'seleccionarTodos',
        ]),
        ...mapActions('matrizCompatibilidadAlmacenamiento', [
            'obtenerComparaciones',
            'obtenerEmpresas',
            'obtenerUbicaciones',
            'obtenerComparacion',
            'guardarComparacion',
            'obtenerProductos',
            'obtenerFabricantes',
            'descargarExcel',
            'fetchCustomFields',
            'fetchCustomFieldValues'
        ]),

        onHandleComparisonIA() {
            this.$refs.modalComparisonRef.productsAttachments = this.$refs.compatibilityRef.productsSorted.map(x => {
                let basePath = x.attachments.replace(process.env.VUE_APP_API_URL, '')
                return {
                    id: x.id,
                    path: basePath.replace('storage/', '')
                }
            })

            // verificar estado de agendamientos 
            this.$refs.modalComparisonRef.onGetComparisonsByMatrixId()

            // Mostrar modal detalles productos
            this.$bvModal.show('modal-mc-comparison-products')
        },

        async cargarProductos() {
            const filtros = { ...this.filtros_productos };
            if (!filtros.id_ubicacion) {
                delete filtros.id_ubicacion;
            }
            await this.obtenerProductos(filtros);
        },
        onBuscarProductos() {
            this.esBusquedaInicial = false;
            this.cargarProductos();
        },

        async onLimpiarProductos() {
            this.restablecerFiltrosProductos();
            this.esBusquedaInicial = true;

            await this.cargarProductos();
        },
        returnAndUpdate() {
            this.$router.push({
                path: '/matriz-compatibilidad/almacenamiento',
                query: { reload: Date.now() }
            });
        },
        async inicializarComponente(calcular = false) {
            const id = this.$route.params.id
            const id_empresa = this.$route.params.id_empresa

            if (id && id_empresa) {
                const parametros = {
                    id,
                    id_empresa,
                    calcular,
                }
                this.fetchCustomFields(id_empresa)
                this.establecerAccion('Editar')

                await this.obtenerComparacion(parametros)
                if (!calcular && this.accion === 'Editar' && this.productos_seleccionados.length >= 2) {
                    this.title = 'Comparando peligrosidades (SGA) y propiedades fisicoquímicas.';
                    this.message = 'Estamos analizando cada producto para contrastar su clasificación según el Sistema Globalmente Armonizado (SGA) con las propiedades fisicoquímicas reportadas. Este proceso puede durar un momento, por favor espera.';
                    this.initloading = true;
                    await this.actualizarComparacion()
                    this.initloading = this.loadingToComparisonIndex;
                }

                await this.cargarProductos();
            }
        },
        async validarFormulario() {
            if (this.comparacion.resultConfig === null) {
                Swal.fire({
                    title: 'Error',
                    icon: 'error',
                    text: 'No ha configurado los resultados desde la administración',
                    type: 'error',
                    confirmButtonText: 'Aceptar',
                })
                return
            } else {
                await this.$validator.validateAll('formulario').then(async (result) => {
                    if (result) {
                        if (this.accion === 'Crear') {
                            this.agregarProducto = false
                            await this.guardarComparacion(this.company_id).then(async () => {
                                this.$router.push(
                                    `/matriz-compatibilidad/almacenamiento/formulario/${this.comparacion.id}/${this.comparacion.id_empresa}`,
                                )
                                this.initloading = true;
                                await this.inicializarComponente()
                                this.initloading = this.loadingToComparisonIndex;
                            })
                        } else if (this.accion === 'Editar') {
                            this.updateDataToComparison()
                        }
                    }
                })
            }
        },
        obtenerUbicacionSeleccionada(ubicaciones) {
            ubicaciones.map((u) => {
                if (u.id === this.filtros_productos.id_ubicacion) {
                    this.establecerUbicacion(u)
                } else if (u.children && !!u.children.length) {
                    this.obtenerUbicacionSeleccionada(u.children)
                }
            })
        },
        validarIgualMateria() {
            if (this.productos_seleccionados[0] && this.productos_seleccionados[1]) {
                if (
                    this.productos_seleccionados[0].lista_estado.lista !==
                    this.productos_seleccionados[1].lista_estado.lista
                ) {
                    return true
                } else {
                    return false
                }
            }
            return false
        },
        getUrlUn(imagen) {
            return `${process.env.VUE_APP_API_URL}/storage/files/un/${imagen}`
        },
        async actionDescargarExcel(item) {
            this.title = 'Revisando las últimas actualizaciones de la clasificación de los productos.';
            this.message = 'Estamos revisando y aplicando las actualizaciones de la clasificación SGA de los productos. Verificamos compatibilidad con tus datos actuales y regeneramos la matriz, resaltando las verificaciones faltantes en caso de ser necesario. Este proceso puede durar un momento, por favor espera.';
            this.initloading = true;
            await this.descargarExcel({ comparacion: item, customFieldId: this.selectedCustomField });
            this.initloading = this.loadingToComparisonIndex;
        },
        onCompanyChange(companyId) {
            this.selectedCustomField = null
            this.obtenerUbicaciones(companyId)
            this.fetchCustomFields(companyId)
        },
        async onCustomFieldChange(fieldId) {
            await this.fetchCustomFieldValues({
                fieldId,
                productIds: this.productos_seleccionados.map(p => p.id),
                companyId: this.comparacion.id_empresa
            })
        }
    },
    beforeDestroy() {
        this.restablecerComparacion()
        this.restablecerFiltrosProductos()
    },
    watch: {
        'filtros_productos.id_ubicacion'() {
            this.obtenerUbicacionSeleccionada(this.ubicaciones)
        },
    },
}
</script>

<style src="../../../../node_modules/@riophae/vue-treeselect/dist/vue-treeselect.min.css"></style>

<style>
.el-select-input-group {
    width: 70%;
}

.button-input-group {
    padding: 4px 10px;
    font-size: 13px;
}

.vue-treeselect__no-children-tip {
    display: none;
}

.pictograma-card:hover,
.un-card:hover {
    transform: scale(1.35);
}

.el-select__tags {
  flex-wrap: wrap;
}

.el-select__input {
  flex-basis: 100%;
  min-width: 100%;
  margin-top: 4px;
}

/* Breakpoint para pantallas anchas (1400px+) */
@media (min-width: 1400px) {
  .col-wide-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
}
</style>
